/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DeliveryNoteArticleStage {
  StructuredDeliverynote = 'STRUCTURED_DELIVERYNOTE',
  UnstructuredDeliverynote = 'UNSTRUCTURED_DELIVERYNOTE',
  TxtExtracted = 'TXT_EXTRACTED',
  ImagesExtracted = 'IMAGES_EXTRACTED',
  AiArticleExtracted = 'AI_ARTICLE_EXTRACTED',
  Failed = 'FAILED',
  Unknown = 'UNKNOWN'
}
